/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/currency'
export default icon
